import {
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Tag,
  Select,
  Textarea,
  Box,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import PerfilAcessoService from "../../../main/services/PerfilAcessoService";
import { useHistory } from "react-router-dom";
import SemRegistros from "../../components/SemRegistros";
import { useAuthProvider } from "../../../Context/AuthProvider";
import { criancaFunc } from "../../../helpers/Funcionalidades";
import { Group } from "../Criancas/Group";

const EditarPerfilAcesso = (props) => {
  let history = useHistory();
  document.title = "MCA - Perfis de Acesso - Editar";

  const { roleKeycloack } = useAuthProvider();
  const _IsMounted = useRef(false);
  const [perfilAcesso, setPerfilAcesso] = useState([]);
  const [descricaoCount, setDescricaoCount] = useState(0);
  const [tiposOrgao, setTiposOrgao] = useState([]);

  useEffect(() => {
    _IsMounted.current = true;
    fetchData();
    fetchTiposOrgao();
    return () => {
      _IsMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function fetchTiposOrgao() {
    PerfilAcessoService.listarTiposOrgao()
      .then((res) => {
        if (_IsMounted.current) setTiposOrgao(res.data);
      })
      .catch(() => {});
  }

  function fetchData() {
    PerfilAcessoService.getPerfilAcesso(props.match.params.id)
      .then((res) => {
        setPerfilAcesso(res.data);
        setDescricaoCount(res.data.descricao ? res.data.descricao.length : 0);

        if (res.data.dataFim !== null) {
          Swal.fire({
            title: "Erro!",
            text: "Você não pode alterar um registro inativo!",
            icon: "error",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          }).then(() => {
            history.push("/perfil-acesso/lista");
          });
        }
      })
      .catch(() => {
        Swal.fire({
          title: "Atenção!",
          text: "Registro não encontrado",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          history.push("/perfil-acesso/lista");
        });
      });
  }

  const validate = (values) => {
    const errors = {};
    if (!values.descricao || values.descricao === "") {
      errors.descricao = "Nome do Perfil é obrigatório!";
    }
    return errors;
  };

  return roleKeycloack && roleKeycloack.includes(criancaFunc.visualizarTudo) ? (
    <Flex
      pt={"20px"}
      px={["5px", "30px"]}
      h="100%"
      flexDir="column"
      w="100%"
      maxW="2000px"
      overflow="auto"
      pb={["10px", "20px"]}
    >
      <Flex flexDir="row" justifyContent="space-between">
        <Heading fontSize={"large"}>Editar Perfil de Acesso</Heading>
        <Button onClick={history.goBack} colorScheme={"teal"} px={16}>
          Voltar
        </Button>
      </Flex>
      <Flex>
        <Formik
          enableReinitialize
          validate={validate}
          validateOnChange={false}
          validateOnBlur={false}
          initialValues={{
            descricao: perfilAcesso.descricao || "",
            tipoOrgaoId:
              tiposOrgao.find((t) => t.nome === perfilAcesso.tipoOrgao)?.id ??
              perfilAcesso.tipoOrgaoId ??
              "",
            tipoOrgao: perfilAcesso.tipoOrgao || "",
            justificativa: perfilAcesso.justificativa || "",
          }}
          onSubmit={(values, actions) => {
            PerfilAcessoService.atualizarPerfilAcesso(perfilAcesso.id, values)
              .then((res) => {
                Swal.fire({
                  title: "Sucesso!",
                  text: "Registro atualizado com sucesso!",
                  icon: "success",
                  confirmButtonText: "Continuar",
                  confirmButtonColor: "#169499",
                }).then(function () {
                  actions.setSubmitting(false);
                  history.push("/perfil-acesso/" + res.data.id);
                });
                actions.setSubmitting(false);
              })
              .catch((error) => {
                actions.setFieldError(
                  error.response && error.response.data.field,
                  error.response && error.response.data.message,
                );
                actions.setSubmitting(false);
              });
          }}
        >
          {(props) => (
            <Flex flexDir="column" mt="40px" w="100%">
              <Form>
                <Flex flexDir="column">
                  <Group bgColor="#fff" title="" py="12px">
                    <Box width={{ lg: "50%" }}>
                      <Field name="descricao">
                        {({ field, form }) => (
                          <Flex flexDir="column">
                            <FormControl
                              isInvalid={
                                form.errors.descricao && form.touched.descricao
                              }
                            >
                              <FormLabel htmlFor="descricao">
                                Nome do Perfil*
                              </FormLabel>
                              <Input
                                h="42px"
                                autoFocus
                                backgroundColor={"white"}
                                id="descricao"
                                {...field}
                                placeholder="Informe o Nome do Perfil de Acesso"
                                maxLength={255}
                                onChange={(e) => {
                                  setDescricaoCount(e.target.value.length);
                                  form.setFieldValue(
                                    field.name,
                                    e.target.value,
                                  );
                                }}
                              />
                              <FormErrorMessage>
                                {form.errors.descricao}
                              </FormErrorMessage>
                            </FormControl>
                          </Flex>
                        )}
                      </Field>
                      <Flex flexDirection="row-reverse">
                        <Tag maxW="max-content">{`${descricaoCount}/255`}</Tag>
                      </Flex>

                      <Field name="tipoOrgaoId">
                        {({ field, form }) => (
                          <Flex mt={5} flexDir="column">
                            <FormControl
                              isInvalid={
                                form.errors.tipoOrgaoId &&
                                form.touched.tipoOrgaoId
                              }
                            >
                              <FormLabel htmlFor="tipoOrgaoId">
                                Tipo de Órgão
                              </FormLabel>
                              <Select
                                backgroundColor={"white"}
                                id="tipoOrgaoId"
                                {...field}
                                placeholder="Selecione o Tipo de Órgão"
                                h="42px"
                                onChange={(e) => {
                                  const selected = tiposOrgao.find(
                                    (t) => String(t.id) === e.target.value,
                                  );
                                  form.setFieldValue(
                                    "tipoOrgaoId",
                                    e.target.value,
                                  );
                                  form.setFieldValue(
                                    "tipoOrgao",
                                    selected ? selected.nome : "",
                                  );
                                }}
                              >
                                {tiposOrgao.map((tipo) => (
                                  <option key={tipo.id} value={tipo.id}>
                                    {tipo.nome}
                                  </option>
                                ))}
                              </Select>
                              <FormErrorMessage>
                                {form.errors.tipoOrgaoId}
                              </FormErrorMessage>
                            </FormControl>
                          </Flex>
                        )}
                      </Field>

                      <Field name="justificativa">
                        {({ field, form }) => (
                          <Flex mt={5} flexDir="column">
                            <FormControl isInvalid={form.errors.justificativa}>
                              <FormLabel htmlFor="justificativa">
                                Justificativa
                              </FormLabel>
                              <Textarea
                                {...field}
                                id="justificativa"
                                backgroundColor="white"
                                placeholder="Justificativa"
                              />
                              <FormErrorMessage>
                                {form.errors.justificativa}
                              </FormErrorMessage>
                            </FormControl>
                          </Flex>
                        )}
                      </Field>
                    </Box>
                  </Group>

                  <Flex mt={2} justifyContent="space-between">
                    <Flex></Flex>
                    <Flex flexDir={["column", "row"]}>
                      <Button
                        mt={4}
                        mr={2}
                        colorScheme="teal"
                        px={14}
                        isLoading={props.isSubmitting}
                        type="submit"
                        translate="no"
                      >
                        Salvar
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>
              </Form>
            </Flex>
          )}
        </Formik>
      </Flex>
    </Flex>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default EditarPerfilAcesso;
